export const chainTypes = {
    SOLANA: 'solana',
    ETHEREUM: 'ethereum',
}

export const chainOptions = [
    {
        key: 'sol',
        name: 'solana',
        value: 'solana',
    },
    {
        key: 'eth',
        name: 'ethereum',
        value: 'ethereum',
    },
]